import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { messages } from '../i18n';
import { ToolTipContentWithKeymap as EmotionToolTipContentWithKeymap } from './ToolTipContentWithKeymap';
import { ToolTipContentWithKeymap as CompiledToolTipContentWithKeymap } from '../compiled/common/ToolTipContentWithKeymap';
import { backspace } from '../../util/keymaps';
import VisuallyHidden from '@atlaskit/visually-hidden';
import { fg } from '@atlaskit/platform-feature-flags';
export var DeletableEmojiTooltipContent = function DeletableEmojiTooltipContent() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  if (fg('platform_editor_css_migrate_emoji')) {
    return /*#__PURE__*/React.createElement(CompiledToolTipContentWithKeymap, {
      description: formatMessage(messages.deleteEmojiTooltip),
      keymap: backspace
    });
  } else {
    return /*#__PURE__*/React.createElement(EmotionToolTipContentWithKeymap, {
      description: formatMessage(messages.deleteEmojiTooltip),
      keymap: backspace
    });
  }
};
export var DeletableEmojiTooltipContentForScreenReader = function DeletableEmojiTooltipContentForScreenReader(_ref) {
  var emoji = _ref.emoji;
  return /*#__PURE__*/React.createElement(VisuallyHidden, {
    id: "screenreader-emoji-".concat(emoji.id)
  }, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.deleteEmojiTooltipForScreenreader, {
    values: {
      shortName: emoji.shortName
    }
  })));
};